/**
 * Class description
 *
 * Created: 2019-08-02
 * @author jonas
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SAReelController, SAReelEvent} from "../reel/SAReelController";
import {SpacierArcadeGameConfig} from "../SpacierArcadeGameConfig";
import {SpacierArcadeReelSymbol} from "../symbols/SpacierArcadeReelSymbol";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameModeTransitionControllerWithView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionControllerWithView";
import {GameModeTransitionView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";
import {SpacierArcadeSoundConfig} from "../SpacierArcadeSoundConfig";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SpacierArcadeParsedGameData} from "../server/data/SpacierArcadeParsedGameData";
import {TimelineLite} from "gsap";


export class SATransitionController extends GameModeTransitionControllerWithView {
    protected _serverData: SpacierArcadeParsedGameData;
    constructor(fromMode:string, toMode:string, view:GameModeTransitionView) {
        super(fromMode, toMode, view);
    }

    /**
     * Set up mode views and layout while screen is covered by intro/outro screen.
     */
    protected prepareToEnterMode():void {
        super.prepareToEnterMode();
        if(this._toMode == GameMode.FREESPIN || this._toMode == SpacierArcadeGameMode.FREESPIN_RESPIN) {
            this.resetIntroSymbols();
        }

        if(this._toMode == GameMode.NORMAL) {
            const tl:TimelineLite = new TimelineLite();
            tl.add(() => {
                this.resetSymbols();
                SlotGame.keypad.setZeroBetSpinCounter(-1);
            }, 0.9);
        }
    }

    protected resetSymbols():void {
        SpacierArcadeGameConfig.instance.reelViewExpanded = false;
        EventHandler.dispatchEvent(new GameEvent(SAReelEvent.SHOW_BASE_GAME_REEL_VIEW));
        [0, 1, 2, 3, 4].forEach((reelId:number) => {
            const reel:SAReelController = <SAReelController>Reels.getReel(reelId);
            reel.resetReelSymbols(SpacierArcadeGameConfig.instance.SYMBOL_HEIGHT, this._serverData!.reelsEnteringFreespin![reelId]);
        });
    }

    private resetIntroSymbols():void{
        SpacierArcadeGameConfig.instance.reelViewExpanded = true;
        EventHandler.dispatchEvent(new GameEvent(SAReelEvent.SHOW_FREE_SPIN_REEL_VIEW));
        this.updateSYmVisibility();
    }

    private updateSYmVisibility():void {
        EventHandler.dispatchEvent(new GameEvent(SAReelEvent.RESET_NEAR_REEL_VIEW));
        [0, 1, 2, 3, 4].forEach((reelId:number) => {
            const reel:SAReelController = <SAReelController>Reels.getReel(reelId);
            reel.resetReelSymbols(SpacierArcadeGameConfig.instance.SYMBOL_HEIGHT_FREESPIN, this._serverData!.reels[reelId], true, 0);

            const symbolAbove:SpacierArcadeReelSymbol = <SpacierArcadeReelSymbol> Reels.getSymbol(reelId, 1);
            if(symbolAbove) {
                symbolAbove.alpha = 1;
            }

            let symbols:(StateReelSymbol|null)[] = Reels.allSymbols(reelId);
            symbols.forEach((sym) => {
                if(sym !== null) {
                    sym.changeState({
                        state: SpacierArcadeGameConfig.instance.SYMBOL_STATES.normal
                    });
                }
            });
        });

    }

}